import { render, staticRenderFns } from "./materials-tab.vue?vue&type=template&id=6e4e3274"
import script from "./materials-tab.vue?vue&type=script&lang=js"
export * from "./materials-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlayerAudioPlayer: require('/usr/src/app/components/player/audio-player.vue').default})
